import { useMemo } from 'react';

import { useWindowSize } from '../../hooks/useWindowSize';

/**
 * Return the number of matches based on the view type and the screen size
 * @param extendedView define if is an extended view
 */
export const useNumberOfMatches = (extendedView: boolean) => {
  const { isTablet } = useWindowSize();
  const numberOfMatches = useMemo(() => {
    if (!extendedView) return 5;

    if (isTablet) return 3;

    return 5;
  }, [extendedView, isTablet]);

  return { numberOfMatches };
};
